module.exports = __webpack_public_path__ + "img/why-2.9240e7a4.webp";